export default __webpack_public_path__ + "static/media/control.e66c7b90.svg";